import React from 'react';

class Toplist extends React.Component {
	render() {
		const { items } = this.props;

		return (
			<div className="student-toplist">
				<h2>Er topplista</h2>

				{ Object.keys(items).map(function(key) {
					return (
						<div className="student-toplist-item" key={ key }>
							<div className="position">{ parseInt(key, 10)+1 }.</div>
							<div className="name">{ items[key].name }</div>
							<div className="shares">{ items[key].shares } andelar</div>
						</div>
					)
				})}
			</div>
		)
	}
}
export default Toplist;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/Home/Toplist.js